import { render, staticRenderFns } from "./signatureTopMenu.vue?vue&type=template&id=db954334&scoped=true"
import script from "./signatureTopMenu.vue?vue&type=script&lang=js"
export * from "./signatureTopMenu.vue?vue&type=script&lang=js"
import style0 from "./signatureTopMenu.vue?vue&type=style&index=0&id=db954334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db954334",
  null
  
)

export default component.exports